import React, { useState, useCallback } from 'react';
import { useIntl } from 'react-intl';
import { Locale } from '../../i18n';
import './Onboarding.scss';

interface OnboardingProps {
  locale: Locale;
  onLocaleChange: (locale: Locale) => void;
  completeOnboarding: () => Promise<void>;
  setLocale: (locale: Locale) => Promise<void>;
}

const Onboarding: React.FC<OnboardingProps> = ({
  locale,
  onLocaleChange,
  completeOnboarding,
  setLocale,
}) => {
  const { formatMessage: t } = useIntl();
  const [selectedLocale, setSelectedLocale] = useState<Locale>(locale);

  const handleLocaleChange = useCallback((newLocale: Locale) => {
    setSelectedLocale(newLocale);
    onLocaleChange(newLocale);
  }, [onLocaleChange]);

  const handleContinue = useCallback(async () => {
    await setLocale(selectedLocale);
    await completeOnboarding();
  }, [completeOnboarding, selectedLocale, setLocale]);

  return (
    <div className="onboarding">
      <div className="onboarding__card">
        <div className="onboarding__step">
          <h1 className="onboarding__title">{t({ id: 'onboarding.language.title' })}</h1>
          <p className="onboarding__subtitle">{t({ id: 'onboarding.language.subtitle' })}</p>
          <label className="onboarding__select-wrap">
            <span className="onboarding__select-label">{t({ id: 'onboarding.language.label' })}</span>
            <select
              className="onboarding__select"
              value={selectedLocale}
              onChange={(event) => handleLocaleChange(event.target.value as Locale)}
            >
              <option value="en">{t({ id: 'onboarding.language.optionEnglish' })}</option>
              <option value="uk">{t({ id: 'onboarding.language.optionUkrainian' })}</option>
            </select>
          </label>
          <div className="onboarding__actions">
            <button className="onboarding__btn onboarding__btn--primary" onClick={handleContinue}>
              {t({ id: 'onboarding.common.next' })}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Onboarding;

